import { useEffect } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000;

function useVersionCheck() {
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION;
    if (!currentVersion) return undefined;

    const check = async () => {
      try {
        const res = await fetch(`/meta.json?t=${Date.now()}`);
        if (!res.ok) return;
        const { version } = await res.json();
        if (version && version !== currentVersion) {
          window.location.reload();
        }
      } catch {
        // Silently fail - network error or file missing
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);
}

export default useVersionCheck;
